import React, { useState } from 'react';
import { ChevronRight, CheckCircle, Lock } from 'lucide-react';

const ParticipantLogin = ({ onLogin, onBack, pendingTestId, pendingRefCode, pendingUid }) => { 
  const [code, setCode] = useState(pendingRefCode || ''); 
  const [grade, setGrade] = useState(''); 
  const [branch, setBranch] = useState(''); 
  const [no, setNo] = useState(''); 
  const [gender, setGender] = useState(''); 
  const [teacherBranch, setTeacherBranch] = useState(''); 
  const [observer, setObserver] = useState('');

const [isCheckingStudent, setIsCheckingStudent] = useState(false);

const LOOKUP_STUDENT_URL =
  "https://us-central1-rehber360-e0808.cloudfunctions.net/lookupStudent";

  const gradeOptions = [
      "Okul Öncesi", "1", "2", "3", "4", "5", "6", "7", "8", "Hazırlık", "9", "10", "11", "12"
  ];
  // 🌟 ÖĞRETMEN BRANŞ LİSTESİ EKLENDİ
  const teacherBranchOptions = [
      "Sınıf Öğretmenliği", "Okul Öncesi", "Türkçe", "Türk Dili ve Edebiyatı", "İlköğretim Matematik",
      "Matematik", "Fen Bilimleri", "Fizik", "Kimya", "Biyoloji", "Sosyal Bilgiler", "Tarih",
      "Coğrafya", "İngilizce", "Din Kültürü ve Ahlak Bilgisi", "Beden Eğitimi", "Görsel Sanatlar",
      "Müzik", "Bilişim Teknolojileri", "Özel Eğitim", "Meslek Dersleri", "Diğer"
  ];
  const genderOptions = ["Kadın", "Erkek"];

  const isParent = pendingTestId?.includes('veli');
  const isTeacher = pendingTestId?.includes('ogretmen');
  const isSnap = pendingTestId === 'snap_iv_form' || pendingTestId?.includes('snap_iv');
  const isStudent = !isParent && !isTeacher && !isSnap;
  const isCodeLocked = !!pendingRefCode; 

 const handleEnter = async () => { 
    const cleanCode = code.trim(); 
    let cleanBranch = branch.trim().toUpperCase();

    if (cleanCode.length < 3) return alert("Lütfen geçerli bir Uzman Kodu giriniz.");

    // 🛡️ AKILLI TEMİZLEYİCİ: Eğer çocuk "9" seçip şubeye "9-A", "9A", "9/A" yazmışsa, o 9'u ve aradaki tireyi yok et!
    if (grade && cleanBranch.startsWith(grade)) {
        cleanBranch = cleanBranch.substring(grade.length).replace(/^[-/\s]+/, '');
    }

    if (isStudent) {

    if (!grade || !cleanBranch || !no) {
        return alert("Lütfen tüm alanları doldurunuz.");
    }

    const studentClass = `${grade}/${cleanBranch}`;
    const studentNo = String(no).trim();

    setIsCheckingStudent(true);

    try {

        const response = await fetch(LOOKUP_STUDENT_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                clinicianCode: cleanCode,
                clinicianUid: pendingUid || null,
                studentClass,
                studentNo
            })
        });

        if (!response.ok) {
            throw new Error('SERVER_ERROR');
        }

        const data = await response.json();

        if (!data.found) {
            alert(
                "Öğrenci bilgileri okul listesiyle eşleşmedi.\n\n" +
                "Lütfen sınıfınızı, şubenizi ve okul numaranızı kontrol ederek tekrar deneyiniz."
            );
            return;
        }

        onLogin(
            cleanCode,
            data.studentClass || studentClass,
            data.studentNo || studentNo,
            data.name,
            data.clinicianUid || pendingUid
        );

    } catch (error) {

        console.error("Öğrenci doğrulama hatası:", error);

        alert(
            "Öğrenci bilgileri şu anda doğrulanamadı.\n\n" +
            "İnternet bağlantınızı kontrol edip tekrar deneyiniz."
        );

    } finally {
        setIsCheckingStudent(false);
    }
} else if (isParent) {
        if (!grade || !cleanBranch || !gender) return alert("Lütfen çocuğunuzun sınıf bilgilerini ve cinsiyetinizi seçiniz.");
        onLogin(cleanCode, `${grade}/${cleanBranch}`, `Veli (${gender})`, null, pendingUid);
    } else if (isTeacher) {
        if (!teacherBranch || !gender) return alert("Lütfen branşınızı ve cinsiyetinizi giriniz.");
        onLogin(cleanCode, "Öğretmen", `${teacherBranch.trim()} (${gender})`, null, pendingUid);
    } else if (isSnap) {
        if (!grade || !cleanBranch || !no || !observer) return alert("Lütfen öğrenci bilgilerini ve formu kimin doldurduğunu seçiniz.");
        onLogin(cleanCode, `${grade}/${cleanBranch}`, `${no} (${observer})`, null, pendingUid);
    }
  };
  
  return (
    // YENİ UI: Arka plana modern gradient eklendi
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4 font-sans no-print">
      
      {/* YENİ UI: Kutuya gölge ve hafif saydamlık (buzlu cam) eklendi */}
      <div className="w-full max-w-md bg-white/90 backdrop-blur-md p-10 rounded-[2rem] shadow-2xl border border-white/50 relative overflow-hidden">
        
        <button onClick={onBack} className="text-slate-500 hover:text-blue-600 transition-colors text-sm font-bold flex items-center mb-8 mt-2">
          <ChevronRight className="rotate-180 h-4 w-4 mr-1"/> Ana Sayfa
        </button>
        
        <h2 className="text-3xl font-black text-slate-900 mb-2">
            {isSnap ? "Öğrenci Değerlendirme" : isParent ? "Veli Girişi" : isTeacher ? "Öğretmen Girişi" : "Öğrenci Girişi"}
        </h2>
        
        {pendingTestId && (
            <div className="bg-blue-50/80 text-blue-700 px-4 py-3 rounded-xl text-sm font-bold mt-2 flex items-center border border-blue-200 shadow-sm backdrop-blur-sm">
                <CheckCircle className="h-5 w-5 mr-2 text-blue-600"/> Forma yönlendirildiniz
            </div>
        )}

        <div className="space-y-5 mt-8">
          <div>
            <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">UZMAN KODU</label>
            {isCodeLocked ? (
                <div className="w-full px-4 py-3 bg-emerald-50/80 border border-emerald-200 text-emerald-700 rounded-xl font-mono text-center font-bold text-xl tracking-widest flex items-center justify-center shadow-sm backdrop-blur-sm">
                    <Lock className="h-5 w-5 mr-2"/> {code}
                </div>
            ) : (
                <input 
                  type="tel" inputMode="numeric" pattern="[0-9]*" 
                  value={code} onChange={e=>setCode(e.target.value.replace(/\D/g, ''))} 
                  className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-mono text-center font-bold text-xl tracking-widest focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
                  placeholder="Örn: 1111"
                />
            )}
          </div>

          {/* SADECE ÖĞRENCİ İÇİN */}
          {isStudent && (
            <>
              <div className="flex gap-4 items-end">
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Sınıf</label>
                  <select value={grade} onChange={e=>setGrade(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                    <option value="">Seç</option>
                    {gradeOptions.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
                <div className="pb-4 text-slate-300 font-black text-xl">/</div>
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Şube</label>
                  <input 
                    type="text" 
                    maxLength="6" 
                    value={branch} 
                    onChange={e => setBranch(e.target.value.toUpperCase().replace(/[^A-ZÇĞİÖŞÜ0-9-]/g, ''))} 
                    className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center uppercase focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
                    placeholder="Örn: A veya BİL-1" 
                  />
                </div>
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Okul No</label>
                <input type="number" value={no} onChange={e=>setNo(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" placeholder="123"/>
              </div>
            </>
          )}

          {/* SADECE VELİ İÇİN */}
          {isParent && (
            <>
              <div className="flex gap-4 items-end">
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Çocuğun Sınıfı</label>
                  <select value={grade} onChange={e=>setGrade(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                    <option value="">Seç</option>
                    {gradeOptions.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
                <div className="pb-4 text-slate-300 font-black text-xl">/</div>
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Şubesi</label>
                  <input 
                    type="text" 
                    maxLength="6" 
                    value={branch} 
                    onChange={e => setBranch(e.target.value.toUpperCase().replace(/[^A-ZÇĞİÖŞÜ0-9-]/g, ''))} 
                    className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center uppercase focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
                    placeholder="Örn: A veya BİL-1" 
                  />
                </div>
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Cinsiyetiniz</label>
                <select value={gender} onChange={e=>setGender(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                  <option value="">Seçiniz</option>
                  {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                </select>
              </div>
            </>
          )}

          {/* SADECE ÖĞRETMEN İÇİN (GÜNCELLENDİ) */}
          {isTeacher && (
            <>
              <div>
                <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Branşınız</label>
                <select value={teacherBranch} onChange={e=>setTeacherBranch(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                  <option value="">Seçiniz</option>
                  {teacherBranchOptions.map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Cinsiyetiniz</label>
                <select value={gender} onChange={e=>setGender(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                  <option value="">Seçiniz</option>
                  {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                </select>
              </div>
            </>
          )}

          {/* SADECE SNAP-IV İÇİN (VELİ / ÖĞRETMEN GÖZLEMCİ) */}
          {isSnap && (
            <>
              <div className="flex gap-4 items-end mb-4">
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Öğrenci Sınıfı</label>
                  <select value={grade} onChange={e=>setGrade(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                    <option value="">Seç</option>
                    {gradeOptions.map(g => <option key={g} value={g}>{g}</option>)}
                  </select>
                </div>
                <div className="pb-4 text-slate-300 font-black text-xl">/</div>
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Şubesi</label>
                  <input 
                    type="text" 
                    maxLength="6" 
                    value={branch} 
                    onChange={e => setBranch(e.target.value.toUpperCase().replace(/[^A-ZÇĞİÖŞÜ0-9-]/g, ''))} 
                    className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center uppercase focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" 
                    placeholder="Örn: A veya BİL-1" 
                  />
                </div>
              </div>
              <div className="flex gap-4 items-end">
                <div className="flex-1">
                  <label className="text-xs font-bold text-slate-500 ml-1 mb-1 block">Öğrenci No</label>
                  <input type="number" value={no} onChange={e=>setNo(e.target.value)} className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl font-bold text-center focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all shadow-sm" placeholder="123"/>
                </div>
                <div className="flex-1">
                  <label className="text-xs font-bold text-indigo-500 ml-1 mb-1 block">Dolduran Kişi</label>
                  <select value={observer} onChange={e=>setObserver(e.target.value)} className="w-full px-4 py-3 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-xl font-bold text-center focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 outline-none cursor-pointer appearance-none transition-all shadow-sm">
                    <option value="">Seçiniz</option>
                    <option value="Veli">Velisi</option>
                    <option value="Öğretmen">Öğretmeni</option>
                  </select>
                </div>
              </div>
            </>
          )}

          <button
  onClick={handleEnter}
  disabled={isCheckingStudent}
  className="w-full py-4 mt-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-wait transition-colors text-white rounded-xl font-bold shadow-lg shadow-blue-200 flex justify-center items-center"
>
  {isCheckingStudent
    ? 'Öğrenci Doğrulanıyor...'
    : pendingTestId
      ? 'Ankete Başla'
      : 'Sisteme Gir'
  }
</button>
        </div>
      </div>
    </div>
  ); 
};

export default ParticipantLogin;